/* Floodlight · home section behaviour (owner: home).
   Ticker speed/skew from scroll velocity, story word parallax, line-up filter + snap counter,
   trust parcel start, scoreboard WhatsApp re-check. Ports prototype 22 (onScrollFrame, reveal) and 26 (tickLoop, onSnap). */
(function () {
  'use strict';
  if (window.SS_LOADED_home) return;
  window.SS_LOADED_home = true;
  var SS = window.SS = window.SS || {};
  var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var reduced = function () { return !!(mq && mq.matches); };
  var qsa = function (root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };
  var pad = function (n) { return (n < 10 ? '0' : '') + n; };
  var emit = function (name, detail) {
    if (typeof SS.emit === 'function') { SS.emit(name, detail || {}); return; }
    try { document.dispatchEvent(new CustomEvent('ss:' + name, { detail: detail || {} })); } catch (e) {}
  };
  var whenIn = function (el, fn) {
    if (el.classList.contains('in')) { fn(); return null; }
    if (!('MutationObserver' in window)) { fn(); return null; }
    var mo = new MutationObserver(function () {
      if (el.classList.contains('in')) { mo.disconnect(); fn(); }
    });
    mo.observe(el, { attributes: true, attributeFilter: ['class'] });
    return mo;
  };

  /* ---------- scroll-driven effects (one listener for all sections) ---------- */
  var tickers = [], words = [], lastSt = null, sraf = 0;

  function tickLoop(tk) {
    if (tk.raf || reduced()) return;
    var anim = null;
    try { anim = tk.track && tk.track.getAnimations ? tk.track.getAnimations()[0] : null; } catch (e) {}
    var step = function () {
      tk.raf = 0;
      if (!tk.el.isConnected) return;
      tk.vel *= 0.9;
      var v = tk.vel;
      tk.el.style.transform = 'skewX(' + (-v * 0.2).toFixed(2) + 'deg)';
      try { if (anim) anim.playbackRate = 1 + Math.min(6, Math.abs(v) * 0.14); } catch (e) {}
      if (Math.abs(v) > 0.05) tk.raf = requestAnimationFrame(step);
      else { tk.el.style.transform = ''; try { if (anim) anim.playbackRate = 1; } catch (e) {} }
    };
    tk.raf = requestAnimationFrame(step);
  }

  function onFrame() {
    sraf = 0;
    var st = window.scrollY || window.pageYOffset || 0;
    var vh = window.innerHeight || 900;
    var dv = lastSt == null ? 0 : st - lastSt;
    lastSt = st;
    if (reduced()) return;
    if (Math.abs(dv) > 0.5) {
      tickers.forEach(function (tk) { tk.vel = Math.max(-60, Math.min(60, dv)); tickLoop(tk); });
    }
    words.forEach(function (wd) {
      var r = wd.parent.getBoundingClientRect();
      if (r.bottom < -200 || r.top > vh + 200) return;
      var p = Math.max(0, Math.min(1, (vh - r.top) / (vh + r.height)));
      wd.el.style.transform = 'translate3d(' + (8 - p * 42).toFixed(2) + '%, 0, 0)';
    });
  }
  function onScroll() { if (!sraf) sraf = requestAnimationFrame(onFrame); }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  var remove = function (arr, item) { var i = arr.indexOf(item); if (i > -1) arr.splice(i, 1); };

  function initHero(sec) {
    var el = sec.querySelector('[data-tk-skew]');
    if (!el || el.__ssTk) return;
    var tk = el.__ssTk = { el: el, track: sec.querySelector('[data-tk]'), vel: 0, raf: 0 };
    tickers.push(tk);
    return function () { cancelAnimationFrame(tk.raf); remove(tickers, tk); el.__ssTk = null; };
  }

  function initStory(sec) {
    var el = sec.querySelector('[data-story-word]');
    if (!el || el.__ssWord) return;
    var wd = el.__ssWord = { el: el, parent: el.parentElement };
    words.push(wd);
    onScroll();
    return function () { remove(words, wd); el.__ssWord = null; };
  }

  /* ---------- line-up: filter tabs + mobile snap counter ---------- */
  function initLineup(sec) {
    var grid = sec.querySelector('[data-lineup-grid]');
    if (!grid || grid.__ssInit) return;
    grid.__ssInit = true;
    var seg = sec.querySelector('[data-seg]');
    var tabs = seg ? qsa(seg, '[data-filter]') : [];
    var ind = seg ? seg.querySelector('.seg-ind') : null;
    var cards = Array.prototype.slice.call(grid.children);
    var snapI = sec.querySelector('[data-snap-i]');
    var snapT = sec.querySelector('[data-snap-total]');
    var bar = sec.querySelector('[data-snap-bar]');
    var fr = 0;

    var visible = function () { return cards.filter(function (c) { return !c.hidden; }); };
    var updateSnap = function () {
      fr = 0;
      if (!snapI) return;
      var vis = visible(), n = vis.length;
      if (!n) return;
      var gap = parseFloat(getComputedStyle(grid).columnGap) || 12;
      var w = vis[0].getBoundingClientRect().width + gap;
      var i = Math.max(0, Math.min(n - 1, Math.round(grid.scrollLeft / Math.max(1, w))));
      var txt = pad(i + 1);
      if (snapI.textContent !== txt) snapI.textContent = txt;
      if (snapT) snapT.textContent = pad(n);
      if (bar) bar.style.transform = 'scaleX(' + ((i + 1) / n).toFixed(3) + ')';
    };
    var onGridScroll = function () { if (!fr) fr = requestAnimationFrame(updateSnap); };

    var apply = function (key, focus) {
      tabs.forEach(function (t, i) {
        var on = t.getAttribute('data-filter') === key;
        t.classList.toggle('on', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (on) {
          if (ind) ind.style.setProperty('--i', i);
          if (t.id) grid.setAttribute('aria-labelledby', t.id);
          if (focus) t.focus();
        }
      });
      cards.forEach(function (c) {
        var kind = (c.getAttribute('data-kind') || '').toLowerCase();
        var show = key === 'all' || kind === key;
        if (show && c.hidden) {
          c.hidden = false;
          if (!reduced()) { c.classList.remove('home-show'); void c.offsetWidth; c.classList.add('home-show'); }
        } else if (!show) {
          c.hidden = true;
          c.classList.remove('home-show');
        }
      });
      grid.scrollLeft = 0;
      updateSnap();
      emit('wa:check');
    };

    var onClick = function (e) {
      var t = e.target.closest ? e.target.closest('[data-filter]') : null;
      if (!t || !seg.contains(t)) return;
      apply(t.getAttribute('data-filter'), false);
    };
    var onKey = function (e) {
      var i = tabs.indexOf(e.target);
      if (i < 0) return;
      var n = tabs.length, j = -1;
      if (e.key === 'ArrowRight') j = (i + 1) % n;
      else if (e.key === 'ArrowLeft') j = (i - 1 + n) % n;
      else if (e.key === 'Home') j = 0;
      else if (e.key === 'End') j = n - 1;
      if (j < 0) return;
      e.preventDefault();
      apply(tabs[j].getAttribute('data-filter'), true);
    };
    if (seg) { seg.addEventListener('click', onClick); seg.addEventListener('keydown', onKey); }
    grid.addEventListener('scroll', onGridScroll, { passive: true });
    window.addEventListener('resize', onGridScroll, { passive: true });
    updateSnap();
    return function () {
      if (seg) { seg.removeEventListener('click', onClick); seg.removeEventListener('keydown', onKey); }
      grid.removeEventListener('scroll', onGridScroll);
      window.removeEventListener('resize', onGridScroll);
      cancelAnimationFrame(fr);
      grid.__ssInit = false;
    };
  }

  /* ---------- trust: start the parcel once the COD tile is revealed ---------- */
  function initTrust(sec) {
    var cod = sec.querySelector('[data-cod]');
    var anim = sec.querySelector('[data-parcel]');
    if (!cod || !anim || typeof anim.beginElement !== 'function') return;
    var started = false, timer = 0, io = null;
    var start = function () {
      if (started || reduced()) return;
      started = true;
      timer = setTimeout(function () { try { anim.beginElement(); } catch (e) {} }, 250);
    };
    var mo = whenIn(cod, start);
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (en) {
        if (!en[en.length - 1].isIntersecting) return;
        if (!document.documentElement.classList.contains('rv-on')) start();
      }, { threshold: 0.1 });
      io.observe(cod);
    } else start();
    return function () { clearTimeout(timer); if (mo) mo.disconnect(); if (io) io.disconnect(); };
  }

  /* ---------- scoreboard: the LED wipe hides text from hit-testing, so re-check WhatsApp after it ---------- */
  function initBoard(sec) {
    var board = sec.querySelector('[data-board]');
    if (!board) return;
    var timer = 0;
    var mo = whenIn(board, function () {
      clearTimeout(timer);
      timer = setTimeout(function () { emit('wa:check'); }, reduced() ? 60 : 2300);
    });
    return function () { clearTimeout(timer); if (mo) mo.disconnect(); };
  }

  function ready(type, init) {
    if (typeof SS.sectionReady === 'function') { SS.sectionReady(type, init); return; }
    var sel = '[data-section-type="' + type + '"]';
    var run = function (root) {
      var els = root.matches && root.matches(sel) ? [root] : root.querySelectorAll(sel);
      Array.prototype.forEach.call(els, function (el) { if (!el.__ssHome) el.__ssHome = init(el) || true; });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(document); });
    else run(document);
    document.addEventListener('shopify:section:load', function (e) { run(e.target); });
    document.addEventListener('shopify:section:unload', function (e) {
      Array.prototype.forEach.call(e.target.querySelectorAll(sel), function (el) {
        if (typeof el.__ssHome === 'function') el.__ssHome();
        el.__ssHome = null;
      });
    });
  }

  ready('home-hero', initHero);
  ready('home-story', initStory);
  ready('home-lineup', initLineup);
  ready('home-trust', initTrust);
  ready('home-scoreboard', initBoard);
})();
